import { Editor } from "@tiptap/react";
import { useEffect, useRef } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { resetActiveEmailRecoilWithouLabel } from "../atoms/ActiveEmailAtom";
import EmailSelectorFamily, { EmailMode } from "../atoms/EmailAtom";
import { RecipientAtom } from "../atoms/RecipientAtom";
import { CountedSavedSearchesAtom } from "../atoms/SavedSearches";
import { UserAtom } from "../atoms/UserAtom";
import { localStorageSetItem } from "../utils/LocalStorage";

function useSetEmail(mode: EmailMode, editor: Editor, index?: number) {
  const [editedEmail, setEditedEmail] = useRecoilState(
    EmailSelectorFamily({ mode, index })
  );

  const user = useRecoilValue(UserAtom);
  const recipient = useRecoilValue(RecipientAtom);
  const savedSearchs = useRecoilValue(CountedSavedSearchesAtom);

  const resetEmailContentRef = useRef(null);

  function resetEmailContent() {
    if (!editor) return;

    //@ts-ignore
    resetActiveEmailRecoilWithouLabel(editedEmail);

    try {
      editor.commands.clearContent();
      editor.commands.setParagraph();
    } catch (err) {
      console.log(err);
    }

    const colors = user?.emailOptions.theme;

    const savedSearch = savedSearchs.find((ss) => ss.id === recipient.searchId);

    if (colors) {
      setEditedEmail((email) => ({
        //@ts-ignore
        ...resetActiveEmailRecoilWithouLabel(email),
        fontColor: colors.textColor,
        backgroundColor: colors.color,
        placeholderColor: colors.placeholderColor,
        titleColor: colors.titleColor,
        titlePlaceholderColor: colors.titlePlaceholderColor,
        labels: savedSearch ? savedSearch.labels : [],
      }));
    } else {
      setEditedEmail((email) => ({
        //@ts-ignore
        ...resetActiveEmailRecoilWithouLabel(email),
        labels: [],
      }));
    }
    localStorageSetItem("DRAFT_EMAIL_SUBJECT", "");
    localStorageSetItem("DRAFT_EMAIL_BODY", "");
    localStorageSetItem(
      "DRAFT_EMAIL_LABELS",
      savedSearch ? JSON.stringify(savedSearch.labels) : "[]"
    );
    localStorageSetItem("DRAFT_EMAIL_SPLIT_SUBJECT", "");
    localStorageSetItem("DRAFT_EMAIL_SPLIT_MODE", "");
  }

  useEffect(() => {
    resetEmailContentRef.current = resetEmailContent;
  }, [resetEmailContent]);

  return { resetEmailContent: resetEmailContentRef };
}

export default useSetEmail;
